import { useAccountContext } from "@contexts/AccountProvider";
import color from "@definitions/mui/color";
import { Box } from "@mui/material";
import MenuLink from "@pwa/layout/MenuLink";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

const Navigation = () => {
  const { t } = useTranslation(["navigation"]);
  const router = useRouter();
  const { isAuth } = useAccountContext();
  const routeBilling = isAuth ? "/billing" : "/tagihan";

  const mainRoutes = [
    {
      title: t("navigation:menu.home"),
      linkPage: isAuth ? "/dashboard" : "/",
      icon: "beranda",
      active: ["/", "/dashboard"],
    },
    {
      title: t("navigation:menu.product"),
      linkPage: isAuth ? "/projects" : "/mobile/produk",
      icon: "produk",
      active: ["/projects", "/mobile/produk"],
    },
    {
      title: t("navigation:menu.invoice"),
      linkPage: routeBilling,
      icon: "tagihan",
      active: ["/billing", "/tagihan"],
    },
    {
      title: t("navigation:menu.account"),
      linkPage: "/profile",
      icon: "akun",
      active: ["/profile"],
    },
  ];

  return (
    <Box
      width="100%"
      height={58}
      position="fixed"
      bottom={0}
      left={0}
      style={{
        backgroundColor: color.white,
        boxShadow: "0px -6px 12px rgba(46, 67, 77, 0.1)",
      }}
      display="flex"
      alignItems="center"
      zIndex={1}
    >
      <Box
        width="100%"
        display="grid"
        gridTemplateColumns="repeat(4, 1fr)"
        style={{ textTransform: "capitalize" }}
      >
        {/* menu footer */}
        {mainRoutes.map((item, idx: number) => (
          <MenuLink
            title={item.title}
            linkPage={item.linkPage}
            active={item.active.includes(router.pathname)}
            key={idx}
            icon={item.icon}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Navigation;
